import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FournisseurService } from '../services/fournisseur.service';
import { FournisseurType, FournisseursModel, FournisseurCardsModel, PaymentCard } from '../models';
import { SepaMandate } from '../models';
import { Right } from '../models/Rights.enum';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { CreditCardsService } from '../services/credit-cards.service';
import { SignatureState } from '../models/signatureState.model';
import { LoaderService } from '../services/loader.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TrackingService } from '../services/tracking.service';

@Component({
  selector: 'fs-payment-means',
  styleUrls: ['./payment-means.sass'],
  templateUrl: './payment-means.component.html',
  encapsulation: ViewEncapsulation.None
})

export class PaymentMeansComponent implements OnInit {
  rights = Right;
  listSepaMandates = new Array<SepaMandate>();
  listInProgressSepaMandates = new Array<Number>();
  allCardsList: FournisseurCardsModel[] = [];
  suppliersList: FournisseursModel[] = [];
  faCheckCircle = faCheckCircle;
  sepaSignStatus;
  sepaSignSupplierId;
  SignatureState = SignatureState;
  cardToRemove;
  faTimes = faTimes;

  constructor(
    public fournisseurService: FournisseurService,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private creditCardsService: CreditCardsService,
    private ngxSmartModalService: NgxSmartModalService,
    private trackingService: TrackingService
  ) { }

  private setDefaultCardId(supplierId: number, cardId: number) {
    this.allCardsList.find(item => item.fournisseurId === supplierId).defaultCardId = cardId;
  }

  getSupplierCardsList(supplierId: number): PaymentCard[] {
    return this.allCardsList.find(item => item.fournisseurId === supplierId).cardsList;
  }

  loadUrlRib(fournisseurType: FournisseurType): string {
    switch (fournisseurType) {
      case FournisseurType.DCF:
        return 'assets/suppliers-rib/RIB_DCF.pdf';

      case FournisseurType.Webimm:
        return 'assets/suppliers-rib/RIB_WEBIMM.pdf';

      default:
        break;
    }
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(resolvedData => {
      this.suppliersList = this.fournisseurService.getSuppliersInfosList();
      const suppliersNb = this.fournisseurService.getSuppliersNb();
      let index = 0;
      for (index; index < suppliersNb; index++) {
        this.allCardsList.push(resolvedData.paymentMeansInfos[index]);
      }
      this.listSepaMandates = resolvedData.paymentMeansInfos[index];
      this.listInProgressSepaMandates = resolvedData.paymentMeansInfos[index + 1];
      this.sepaSignStatus = +this.activatedRoute.snapshot.queryParams['sepaSignStatus'];
      this.sepaSignSupplierId = +this.activatedRoute.snapshot.queryParams['sepaSignSupplierId'];
      this.trackingService.pushEvent('financial-payment_means');
      this.trackingService.pushPageViewGA4('financial_payment_means');
      this.loaderService.decreaseLoaderCount();
    });
  }

  getDefaultCardId(supplierId: number): number {
    return this.allCardsList.find(item => item.fournisseurId === supplierId).defaultCardId;
  }

  onClickCard(cardsInfos: any) {
    if (this.getDefaultCardId(cardsInfos.supplierId) === cardsInfos.cardId) {
      return;
    }
    this.creditCardsService.putDefaultCard(cardsInfos.cardId).subscribe(response => {
      if (response) {
        this.allCardsList.find(item => item.fournisseurId === cardsInfos.supplierId).defaultCardId = cardsInfos.cardId;
      }
    });
  }

  onClickRemoveCard(cardsInfos: any) {
    this.cardToRemove = cardsInfos;
    this.ngxSmartModalService.open('removeCardModal');
  }

  onRemoveCardConfirmed() {
    this.loaderService.increaseLoaderCount();
    this.creditCardsService.removeCard(this.cardToRemove.cardId).subscribe(response => {
      if (response) {
        const removeIndex = this.getSupplierCardsList(this.cardToRemove.supplierId)
          .findIndex(card => card.PaymentMethodCardId === this.cardToRemove.cardId);
        this.getSupplierCardsList(this.cardToRemove.supplierId).splice(removeIndex, 1);
        if (this.cardToRemove.cardId === this.getDefaultCardId(this.cardToRemove.supplierId)) {
          this.setDefaultCardId(this.cardToRemove.supplierId, null);
        }
        this.ngxSmartModalService.close('removeCardModal');
        this.loaderService.decreaseLoaderCount();
      }
    });
  }

  logoSupplier(supplier: number): string {
    let cssClass: string;

    switch (supplier) {
      case FournisseurType.Webimm:
        cssClass = 'logo_webimm';
        break;

      case FournisseurType.DCF:
        cssClass = 'logo_goupe_seloger';
        break;
    }

    return cssClass;
  }

  contractSupplier(supplier: number): string {
    let contrats: string;

    switch (supplier) {
      case FournisseurType.Webimm:
        contrats = 'SeLoger bureaux & commerces';
        break;

      case FournisseurType.DCF:
        contrats = 'Digital Classified France';
        break;
    }

    return contrats;
  }

  loadSepaMandate(supplierId: number): SepaMandate {
    return this.listSepaMandates.find(f => f.SupplierId === supplierId);
  }

  hasSepaMandateInProgress(supplierId: number): Number {
    return this.listInProgressSepaMandates.find(f => f === supplierId);
  }

}
